import React from 'react';
import ReactDOM from 'react-dom';
import FastClick from 'fastclick';
import { addLocaleData } from 'react-intl';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore TODO add defs for analytics
import { trackAuthUser } from '@fenderdigital/analytics';
import en from 'react-intl/locale-data/en';
import 'intersection-observer';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { decorateWindow, loadSegment } from './core/segment';
import { trackPerformanceMetrics } from './lib/analytics';
import Cognito from './lib/cognito';
import App from './components/App';
import configureStore from './store/configureStore';
import * as serviceWorker from './serviceWorker';
import bugsnagClient from './core/bugsnag';

trackPerformanceMetrics();
decorateWindow();
[en].forEach(addLocaleData);

const siteId = process.env.REACT_APP_CLIENT_SITE_ID || 'play';

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
    ga: UniversalAnalytics.ga;
    _fender_perf: ['string', number][];
    APP_STATE: object;
  }
}

interface CognitoResponse {
  'first-name': string;
  'last-name': string;
  userID: string;
  token: string;
}
// First page load track event
Cognito.fetchCognitoCredentials().then(
  (response): void => {
    let id: string | undefined;
    let firstName: string | undefined;
    let lastName: string | undefined;
    if (response) {
      id = response.userID;
      firstName = response['first-name'];
      lastName = response['last-name'];
      bugsnagClient.user = { id };
    }
    trackAuthUser(siteId, {
      id,
      identitySource: 'Fender Play',
      firstName,
      lastName,
    });
  },
  (): void => {},
);

const store = configureStore(window.APP_STATE);

interface ScrollPositionHistory {
  [key: string]: {
    scrollX: number;
    scrollY: number;
  };
}

// Make taps on links and buttons work fast on mobiles
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore TODO get typedefs
FastClick.attach(document.body);

const ErrorBoundary = bugsnagClient.getPlugin('react');

const container = document.getElementById('app');
// Re-render the app when window.location changes
function main(): void {
  try {
    ReactDOM.hydrate(
      <ErrorBoundary>
        <HelmetProvider>
          <Provider store={store}>
            <Router basename={process.env.REACT_APP_CLIENT_PATH_PREFIX}>
              <App queryParams={new URL(window.location.href).searchParams} store={store} />
            </Router>
          </Provider>
        </HelmetProvider>
      </ErrorBoundary>,
      container,
      loadSegment,
    );
  } catch (error) {
    // Display the error in full-screen for development mode
    if (process.env.NODE_ENV === 'development') {
      throw error;
    }

    console.error(error); // eslint-disable-line no-console
  }
}

main();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
